import React, { useState } from 'react';
import { Eye, Check, X } from 'lucide-react';
import toast from 'react-hot-toast';
import { useSupabase } from '../../hooks/useSupabase';
import { aicisAPI } from '../../services/api';
import DataTable from '../../components/Tables/DataTable';
import { formatDate, formatCurrency, getStatusColor, getStatusLabel } from '../../utils/helpers';

export default function AffiliatePurchases() {
  const { data, refetch } = useSupabase(aicisAPI.getAffiliatePurchases);
  const [processingId, setProcessingId] = useState(null);

  const handleStatusUpdate = async (id, status) => {
    setProcessingId(id);
    try {
      await aicisAPI.updateAffiliatePurchase(id, { status });
      toast.success(`Purchase ${status} successfully`);
      refetch();
    } catch (error) {
      toast.error(`Failed to ${status} purchase`);
    } finally {
      setProcessingId(null);
    }
  };

  const columns = [
    { key: 'transaction_id', label: 'Transaction ID', sortable: true },
    { key: 'full_name', label: 'Full Name', sortable: true },
    { key: 'email', label: 'Email', sortable: true },
    { key: 'phone', label: 'Phone' },
    { key: 'organization', label: 'Organization' },
    { key: 'package_title', label: 'Package' },
    { 
      key: 'package_price', 
      label: 'Price',
      render: (value) => formatCurrency(value)
    },
    { 
      key: 'status', 
      label: 'Status',
      render: (value) => (
        <span className={`badge ${getStatusColor(value)}`}>
          {getStatusLabel(value)}
        </span>
      )
    },
    { 
      key: 'created_at', 
      label: 'Date',
      render: (value) => formatDate(value)
    },
  ];

  const actions = [
    {
      label: 'View',
      icon: <Eye className="w-4 h-4" />,
      onClick: (item) => console.log('View:', item),
      className: 'text-blue-600 hover:bg-blue-50',
      showWhen: ['pending', 'completed', 'rejected']
    },
    {
      label: 'Approve',
      icon: <Check className="w-4 h-4" />,
      onClick: (item) => handleStatusUpdate(item.id, 'completed'),
      className: 'text-green-600 hover:bg-green-50',
      showWhen: ['pending'],
      disabled: (item) => processingId === item.id
    },
    {
      label: 'Reject',
      icon: <X className="w-4 h-4" />,
      onClick: (item) => handleStatusUpdate(item.id, 'rejected'),
      className: 'text-red-600 hover:bg-red-50',
      showWhen: ['pending'],
      disabled: (item) => processingId === item.id
    },
  ];

  return (
    <div>
      <div className="mb-6">
        <h1 className="text-2xl font-bold text-gray-900">Affiliate Purchases</h1>
        <p className="text-gray-600">Manage affiliate package purchases</p>
      </div>

      <DataTable
        columns={columns}
        data={data || []}
        title={`Total: ${data?.length || 0} purchases`}
        actions={actions}
        searchPlaceholder="Search purchases..."
      />
    </div>
  );
}